import styled from 'styled-components';
import {
  Nav,
} from 'react-bootstrap';

const CardsNav = styled(Nav)`
  text-align: center;
  padding-bottom: 20px;

  li {
    display: inline-block;
    float: none;
  }
`;

export default CardsNav;



// WEBPACK FOOTER //
// ./src/components/ui/CardsNav.js